export const THOUGHTSPOT_HOST = process.env.REACT_APP_TS_URL || process.env.REACT_APP_THOUGHTSPOT_HOST || '';
export const LIVEBOARD_ID = '1d8000d8-6225-4202-b56c-786fd73f95ad' || '';
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY || '';
export const USERNAME = process.env.REACT_APP_USERNAME || '';
